import React from "react"
import {
  useI18next,
} from "gatsby-plugin-react-i18next"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ContactContent from "../components/contact-content"



const ContactPage = () => {
  const {t} = useI18next();
  return (
    <Layout>
      <SEO title={t("MENU.CONTACT")} />
      <ContactContent/>
    </Layout>
  )
}


export default ContactPage